import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Organisation } from 'src/types/shared/Organisation';

export const fetchOrganisationRequest = createAction('fetchOrganisationRequest');
export const fetchOrganisationSuccess = createAction<Organisation>('fetchOrganisationSuccess');
export const fetchOrganisationFailure = createAction('fetchOrganisationFailure');

export const fetchOrganisation = (submissionID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchOrganisationRequest());
    try {
        const { data } = await api.get<Organisation>(
            `admin/assessments/edit-application/${submissionID}`,
        );

        dispatch(fetchOrganisationSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchOrganisationFailure, e as any);
    }
};
